export default __webpack_public_path__ + "static/media/cwu3.bf97324a.jpeg";